import { CART_MODULE } from "@/api_framework/api_config";
import { ICartDetailsResponse, ICartDetailsResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setActiveCartDetails } from "@/app_redux/reducers/slices/auth/cart_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useCartDetailsAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<ICartDetailsResponseData>(null);
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
      cartId: string,
      clinicId: string,
      cartType: "normal" | "hd",
      cartLevelCoupon?: string,
      pincode?: string,
      showMessage?: string,
      isRefreshCart?: boolean,
      noErrorMessage?: boolean,
    ) => {
      try {
        if (!isRefreshCart) {
          dispatch(
            setLoading({
              key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
              status: true,
            }),
          );
        }
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartDetailsResponseData | null = await axios
          .get(`${CART_MODULE?.CART_DETAILS?.baseURL}`, {
            params: {
              cart_id: cartId,
              clinic_id: clinicId,
              cart_level_coupon_id: cartLevelCoupon
                ? cartLevelCoupon === "remove"
                  ? undefined
                  : cartLevelCoupon
                : undefined,
              remove_coupon: cartLevelCoupon === "remove" ? true : undefined,
              pincode: pincode ?? "",
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartDetailsResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              if (showMessage === "showMessage") {
                toastNotification(res.data.message);
              }
              dispatch(setActiveCartDetails(res.data.data));
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return res.data.data;
            } else {
              setData(null);
              dispatch(setActiveCartDetails(null));
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setData(null);
            sendCurl(e.config["curlCommand"]);
            dispatch(setActiveCartDetails(null));
            !noErrorMessage && captureError(e);
            dispatch(
              setLoading({
                key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                status: false,
              }),
            );
            return null;
          });
        return response;
      } catch (e) {
        setData(null);
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: false,
          }),
        );
        !noErrorMessage && captureError(e);
      }
    },
    [dispatch],
  );
  return { data, execute };
};
